export const isAdminPanel = window.location.href.includes('/admin');
